// Autonomy of automated processes: types shared with the web app (browser-safe, no database code).

export type AutonomyLevel = 'confirm' | 'auto';

/** Processes whose autonomy the board can set. Each one's guardrails are enforced where the process runs. */
export const AUTOMATIONS = ['requests.reply', 'collections.reminders', 'ledger.bank_match', 'insurance.review', 'maintenance.dispatch', 'maintenance.invoices', 'reservations.approve'] as const;
export type Automation = (typeof AUTOMATIONS)[number];

/** Processes that need a limit (in cents) before they can be automatic. */
export const LIMITED_AUTOMATIONS: readonly Automation[] = ['maintenance.dispatch', 'maintenance.invoices'];

export interface AutonomySetting {
  process: Automation;
  level: AutonomyLevel;
  /** Amount limit in cents, for processes that take one (null: not set). */
  limitCents: number | null;
  updatedAt: string | null;
  updatedBy: string | null;
  /** People's decisions on what the agent prepared, over the last 90 days: how many agreed with it. */
  accuracy: { agreed: number; total: number };
}
export interface AutonomyChange {
  id: string;
  process: string;
  level: AutonomyLevel;
  limitCents: number | null;
  note: string;
  changedBy: string | null;
  changedAt: string;
}
export interface AutomationLogEntry {
  id: string;
  process: string;
  summary: string;
  subjectType: string | null;
  subjectId: string | null;
  createdAt: string;
}

/** Enough decisions, nearly all agreeing: the board may consider automatic mode. */
export const READY_MIN_DECISIONS = 10;
export const READY_MIN_RATE = 0.95;
export const readyForAuto = (a: { agreed: number; total: number }) => a.total >= READY_MIN_DECISIONS && a.agreed / a.total >= READY_MIN_RATE;
